package org.teddapp.project.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

/**
 * Touche de clavier : rappelle un raccourci à côté de l'action qu'il déclenche.
 * [onFill] est vrai quand la touche est posée sur un bouton plein ; elle prend alors
 * la couleur du libellé au lieu de sa propre surface.
 */
@Composable
fun TeddKbd(
    text: String,
    modifier: Modifier = Modifier,
    onFill: Boolean = false,
    color: Color = TeddTokens.InkMuted,
) {
    val shape = RoundedCornerShape(TeddTokens.RXs)
    Box(
        modifier = modifier
            .then(if (onFill) Modifier else Modifier.background(TeddTokens.Surface, shape))
            .border(1.dp, if (onFill) color.copy(alpha = 0.7f) else TeddTokens.Line, shape)
            .defaultMinSize(minWidth = 18.dp)
            .padding(horizontal = 5.dp, vertical = 1.dp),
        contentAlignment = Alignment.Center,
    ) {
        Text(
            text = text,
            color = if (onFill) color.copy(alpha = 0.85f) else color,
            style = TeddType.MonoSm.copy(fontSize = 11.sp),
            maxLines = 1,
        )
    }
}
